import axios from "../axios";

export const getAllStudents = async() => {
   const {data} = await axios.get('students/all')

   return data
}